import type {TvmList} from '../../types'

export const PRODUCTION = {
  exp3: {host: 'exp3-matcher.taxi.yandex.net', name: 'experiments3', id: 2013674},
  account: {name: 'delivery-frontend-account', id: 2049691},
  auth: {name: 'delivery-frontend-auth', id: 2049639},
  route: {name: 'delivery-frontend-route', id: 2049683},
  tariffs: {name: 'delivery-frontend-tariffs', id: 2046187},
} as const satisfies TvmList
